const { default: routes } = require("components/routes");

export const PRODUCTS_ROUTES = {
  health_insurance: [
    routes.FLEX_PRICING_SETUP,
    routes.FLEX_ATTRIBUTE_SETUP,
    routes.PRE_CORPORATE_BUFFER,
    routes.FLEX_TPA_SETUP,
  ],
  personal_accident: [routes.FLEX_GPA_SETUP],
  term_life: [routes.FLEX_GPA_SETUP],
  opd_cover: [routes.FLEX_PRICING_SETUP],
  critical_illness: [routes.FLEX_PRICING_SETUP],
  health_checkup: [routes.FLEX_PRICING_SETUP],
  mandatory_top_up_health: [routes.FLEX_PRICING_SETUP],
  top_up_health: [routes.FLEX_PRICING_SETUP, routes.FLEX_TPA_SETUP],
  parental_cover: [routes.FLEX_PRICING_SETUP, routes.FLEX_TPA_SETUP],
  health_insurance_parents: [routes.FLEX_PRICING_SETUP],
  health_insurance_parents_in_laws: [routes.FLEX_PRICING_SETUP],
};

export const FLEX_PRODUCTS = [
  {
    display_name: "Group Mediclaim Cover",
    value: "health_insurance",
  },
  {
    display_name: "Group Mediclaim Cover (Additional)",
    value: "health_insurance_additional",
  },
  {
    display_name: "Group Personal Accident",
    value: "personal_accident",
  },
  {
    display_name: "Group Term Life",
    value: "term_life",
  },
  {
    display_name: "OPD Cover",
    value: "opd_cover",
  },
  {
    display_name: "Critical Illness",
    value: "critical_illness",
  },
  {
    display_name: "Health Checkup",
    value: "health_checkup",
  },
  {
    display_name: "Mandatory Top Up Health",
    value: "mandatory_top_up_health",
  },
  {
    display_name: "Top Up Health",
    value: "top_up_health",
  },
  {
    display_name: "Parental Cover",
    value: "parental_cover",
  },
  {
    display_name: "Group Mediclaim Cover (Parents)",
    value: "health_insurance_parents",
  },
  {
    display_name: "Group Mediclaim Cover (Parents-In-Laws)",
    value: "health_insurance_parents_in_laws",
  },
  {
    display_name: "Health Check-ups",
    value: "HEALTH_CHECKUP",
  },
  {
    display_name: "Doctor Consultation",
    value: "DOCTOR_CONSULTATION",
  },
  {
    display_name: "Mental Wellbeing",
    value: "MENTAL_WELLBEING",
  },
  {
    display_name: "Fitness",
    value: "FITNESS",
  },
  {
    display_name: "Dental",
    value: "DENTAL",
  }
];

export const AMOUNT_PER_MIL_MULTIPLIERS = [
  {
    label: "1.5x",
    value: 1.5,
  },
  {
    label: "2x",
    value: 2,
  },
  {
    label: "3x",
    value: 3,
  },
  {
    label: "5x",
    value: 5,
  },
];
